enum RoleEnum {
  CUSTOMER = "CUSTOMER",
  DPD = "DPD",
  ADMIN = "ADMIN",
  GDPR = "GDPR",
  CUSTOMER_COMPANY = "CUSTOMER_COMPANY"
}

const ALL = [RoleEnum.CUSTOMER, RoleEnum.CUSTOMER_COMPANY, RoleEnum.DPD, RoleEnum.ADMIN, RoleEnum.GDPR]

const GDPR_ADMIN_GROUP = [RoleEnum.ADMIN, RoleEnum.GDPR]

const DPD_AND_ADMIN = [RoleEnum.DPD, RoleEnum.ADMIN]

const WORKFLOW_GROUP = [RoleEnum.CUSTOMER, RoleEnum.DPD, RoleEnum.ADMIN]


export {
  RoleEnum,
  ALL,
  DPD_AND_ADMIN,
  WORKFLOW_GROUP,
  GDPR_ADMIN_GROUP
}
